<div class="wrap">
  <form [formGroup]="form">
    <div class="payment_offer">
      <h4>Paiement de l'offre</h4>

      <div class="isPayableAtClub_isPayableOnline">
        <mat-slide-toggle [checked]="isPayableAtClub" [color]="color" (change)="changeToggle('isPayableAtClub')"
          formControlName="isPayableAtClub">
          Paiement au club</mat-slide-toggle>
        <mat-slide-toggle [checked]="isPayableOnline" [color]="color" (change)="changeToggle('isPayableOnline')"
          formControlName="isPayableOnline">
          Paiement en ligne</mat-slide-toggle>
      </div>

      <div class="price_advance_payment">
        <mat-form-field appearance="outline">
          <mat-label>Prix fixe (€)</mat-label>
          <input type="number" matInput formControlName="fixedPrice" (input)="formIsValid()">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Acompte (€)</mat-label>
          <input type="number" matInput formControlName="advancePayment" (input)="formIsValid()">
        </mat-form-field>
      </div>
    </div>

    <div class="reduction_offer">
      <h4>Réductions pour l'offre</h4>

      <div class="reduction_offer_item" appChangeColorTheme attribute="border" rgba="0.5" borderPx="2px">
        <h5>
          <fa-icon [icon]="getFaIcon('faInfoCircle')" [matTooltip]="getTooltip('reductionAge')" appChangeColorTheme
            attribute="color"></fa-icon>
          Remise age

        </h5>
        <app-active-or-deactive-pricing></app-active-or-deactive-pricing>

        <div class="item_reduction_age">
          <div class="add_age" (click)="addAgeGroup()" appChangeColorTheme attribute="color">
            <div class="add_age_content">
              <fa-icon [icon]="getFaIcon('faPlus')"></fa-icon>
              <span>Ajouter une tranche d'age</span>
            </div>
          </div>

          <div class="age_group_and_delete">
            <div class="formArray_area" formArrayName="remAge">

              <ng-container *ngFor="let item of selectionAgeGroup.controls; let i = index;">

                <div class="ageGroup_content" [formGroup]="item">

                  <div class="age_min_max" formArrayName="limits">

                    <ng-container *ngFor="let el of getselectionAgeGroupValues(i)?.controls; let vI = index;">

                      <div [formGroup]="el" class="age_min_max_content">
                        <mat-form-field appearance="outline" class="age">
                          <mat-label>Age minimum</mat-label>
                          <input type="number" matInput formControlName="min" (input)="setValidatorsAgeGroup()">
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="age">
                          <mat-label>Age maximum</mat-label>
                          <input type="number" matInput formControlName="max" (input)="setValidatorsAgeGroup()">
                        </mat-form-field>
                      </div>

                    </ng-container>

                  </div>

                  <mat-form-field appearance="outline" class="reduction">
                    <mat-label>Prix remisé</mat-label>
                    <input type="number" matInput formControlName="price" [min]="0" [max]="100" (input)="formIsValid()">
                  </mat-form-field>

                  <div class="delete_ageGroup">
                    <fa-icon [icon]="getFaIcon('faTrashAlt')" (click)="deletedSelectionAgeGroup(i)"></fa-icon>
                  </div>
                </div>

              </ng-container>


            </div>

          </div>
        </div>
      </div>

      <div class="reduction_offer_item" appChangeColorTheme attribute="border" rgba="0.5" borderPx="2px">
        <h5>
          <fa-icon [icon]="getFaIcon('faInfoCircle')" [matTooltip]="getTooltip('reductionQuantity')" appChangeColorTheme
            attribute="color"></fa-icon>
          Remise quantité
        </h5>
        <app-active-or-deactive-pricing></app-active-or-deactive-pricing>
        <div class="item_reduction">

          <div formArrayName="remQTE" class="formArray_area">
            <ng-container *ngFor="let item of selectionRemQTE.controls; let i = index;">
              <div class="formArray_area_content" [formGroup]="item">
                <mat-form-field appearance="outline">
                  <mat-label>Quantité</mat-label>
                  <input type="number" matInput formControlName="quantity" [min]="0" (input)="formIsValid()">
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>% remise</mat-label>
                  <input type="number" matInput formControlName="reduction" [min]="0" [max]="100"
                    (input)="formIsValid()">
                </mat-form-field>


              </div>
            </ng-container>


          </div>

        </div>
      </div>

      <div class="reduction_offer_item" appChangeColorTheme attribute="border" rgba="0.5" borderPx="2px">
        <h5>
          <fa-icon [icon]="getFaIcon('faInfoCircle')" [matTooltip]="getTooltip('reductionLicence')" appChangeColorTheme
            attribute="color"></fa-icon>
          Remise titre fédéral
        </h5>
        <app-active-or-deactive-pricing></app-active-or-deactive-pricing>

        <div class="item_reduction">
          <mat-form-field appearance="outline">
            <mat-label>% remise</mat-label>
            <input type="number" matInput formControlName="remTFED" [min]="0" [max]="100" (input)="formIsValid()">
          </mat-form-field>
        </div>
      </div>

      <div class="reduction_offer_item" appChangeColorTheme attribute="border" rgba="0.5" borderPx="2px">
        <h5>
          <fa-icon [icon]="getFaIcon('faInfoCircle')" [matTooltip]="getTooltip('reductionCity')" appChangeColorTheme
            attribute="color"></fa-icon>
          Remise ville de résidence
        </h5>
        <app-active-or-deactive-pricing></app-active-or-deactive-pricing>

        <div class="rem_city">
          <div class="add_city">
            <mat-form-field appearance="outline">
              <mat-label>Choix des villes</mat-label>
              <input type="text" matInput formControlName="remVRES" [maxlength]="5" placeholder="ex: 59000"
                appNumbersOnly>
            </mat-form-field>
            <fa-icon [icon]="getFaIcon('faPlus')" [style.opacity]="f.remVRES.value ? 1 : .5"
              (click)="f.remVRES.value ? addCityInRemVRES() : null" appChangeColorTheme attribute="bgc"></fa-icon>
          </div>
          <mat-form-field appearance="outline" class="city_pourcent">
            <mat-label>% remise</mat-label>
            <input type="number" matInput formControlName="remVRESPercentage" (input)="formIsValid()">
          </mat-form-field>
        </div>
        <p>Liste des villes</p>
        <p *ngIf="!cityRemVRES.length" [style.text-align]="'center'">Aucune ville</p>

        <ul>
          <li *ngFor="let c of cityRemVRES, let i = index">
            {{c}}
            <fa-icon [icon]="getFaIcon('faTrashAlt')" (click)="deleteCityInRemVRES(i)"></fa-icon>
          </li>
        </ul>
      </div>

      <div class="reduction_offer_item" appChangeColorTheme attribute="border" rgba="0.5" borderPx="2px">
        <h5>
          <fa-icon [icon]="getFaIcon('faInfoCircle')" [matTooltip]="getTooltip('reductionStagiaire')"
            appChangeColorTheme attribute="color"></fa-icon>
          Remise stagiaire
        </h5>
        <!-- <mat-slide-toggle [color]="color" [checked]="false">inactif</mat-slide-toggle> -->
        <app-active-or-deactive-pricing></app-active-or-deactive-pricing>

        <div class="item_reduction">
          <div formArrayName="remStagiaires" class="formArray_area">
            <ng-container *ngFor="let item of selectionStagiaires.controls; let i = index;">
              <div class="formArray_area_content" [formGroup]="item">
                <mat-form-field appearance="outline">
                  <mat-label>Quantité</mat-label>
                  <input type="number" matInput formControlName="quantity" [min]="0" (input)="formIsValid()">
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>% remise</mat-label>
                  <input type="number" matInput formControlName="reduction" [min]="0" [max]="100"
                    (input)="formIsValid()">
                </mat-form-field>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

    </div>
  </form>

</div>